import React, { useState } from 'react';
import 'tailwindcss/tailwind.css';
//import logoFull from "../../images/logoAnimado.gif";
import "../../../App.css";
import { registerUser, usuario } from '../../http/Actions/AuthAction';
import { paises } from '../../data/Countries';
import { useNavigate } from 'react-router-dom';

const RegisterPage = () => {
    const navigate = useNavigate();
  const [user, setUser] = useState(usuario);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [registerError, setRegisterError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(''); // Nuevo estado para mensaje de éxito
  const [passwordError, setPasswordError] = useState('');
  const [passwordMatchError, setPasswordMatchError] = useState('');
  const [emailError, setEmailError] = useState('');

  // Resto de funciones sin cambios...
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });

    if (name === 'Email') {
      checkEmailValidity(value);
    }
  };

  const handlePasswordChange = (e) => {
    const { value } = e.target;
    setPassword(value);
    checkPasswordStrength(value);
  };

  const handleConfirmPasswordChange = (e) => {
    const { value } = e.target;
    setConfirmPassword(value);
    checkPasswordMatch(value);
  };

  const checkPasswordStrength = (password) => {
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (!strongPasswordRegex.test(password)) {
      setPasswordError('La contraseña debe tener al menos 8 caracteres, incluyendo una mayúscula, una minúscula, un número y un carácter especial.');
    } else {
      setPasswordError('');
    }
  };

  const checkPasswordMatch = (confirmPassword) => {
    if (confirmPassword !== password) {
      setPasswordMatchError('Las contraseñas no coinciden.');
    } else {
      setPasswordMatchError('');
    }
  };

  const checkEmailValidity = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError('El correo electrónico no es válido.');
    } else {
      setEmailError('');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Limpiar mensajes anteriores
    setSuccessMessage('');
    setRegisterError(null);
    
    if (passwordError || passwordMatchError || emailError) {
      setRegisterError({ message: 'Corrige los errores antes de continuar.' });
      return;
    }
    
    try {
      const response = await registerUser({ ...user, Password: password }, setRegisterError);
      
      // Mostrar mensaje de éxito
      if (response && response.status === 201) {
        setSuccessMessage(response.message || 'Usuario creado exitosamente. Por favor verifica tu correo electrónico para activar tu cuenta.');
        
        // Opcional: Limpiar el formulario después del registro exitoso
        setUser(usuario);
        setPassword('');
        setConfirmPassword('');
        navigate('/registro-exitoso');
        
        // Opcional: Redirigir después de unos segundos
        // setTimeout(() => {
        //   window.location.href = '/login';
        // }, 3000);
      }
    } catch (error) {
      console.error('Registration failed:', error);
      // El error ya debe estar siendo manejado por setRegisterError en la función registerUser
    }
  };

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-black relative"
      style={{
        backgroundImage: 'url(https://i.postimg.cc/rw3XpzPP/wallpaper.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full bg-black bg-opacity-50"></div>
      
      <div className="z-10 max-w-3xl w-full">
        <div className="text-center mb-8">
          <h2 className="mt-6 text-4xl font-extrabold text-white">
            Únete a la comunidad
          </h2>
          <p className="mt-2 text-sm text-gray-300">
            Regístrate para acceder a los mejores shows de stand up y eventos en vivo.
          </p>
        </div>
        
        <div className="bg-zinc-900 rounded-2xl shadow-xl overflow-hidden">
          <form className="p-8" onSubmit={handleSubmit}>
            {/* Mensaje de éxito */}
            {successMessage && (
              <div className="bg-green-500/20 border border-green-500 text-green-100 px-4 py-3 rounded mb-6">
                <p className="text-sm">{successMessage}</p>
              </div>
            )}
            
            {/* Mensaje de error */}
            {registerError && (
              <div className="bg-red-500/20 border border-red-500 text-red-100 px-4 py-3 rounded mb-6">
                <p className="text-sm">{registerError.message}</p>
              </div>
            )}
            
            {/* Resto del formulario sin cambios */}
            {/* ... */}
            
            {/* Campos de formulario existentes */}
            {/* Nombre y Apellido en la misma fila */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="firstName">
                  Nombre
                </label>
                <input
                  id="firstName"
                  type="text"
                  name="FirstName"
                  placeholder="Tu nombre"
                  value={user.FirstName}
                  onChange={handleChange}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  required
                />
              </div>
              
              <div>
                <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="lastName">
                  Apellido
                </label>
                <input
                  id="lastName"
                  type="text"
                  name="LastName"
                  placeholder="Tu apellido"
                  value={user.LastName}
                  onChange={handleChange}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  required
                />
              </div>
            </div>
            
            {/* Email y Teléfono en la misma fila */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  name="Email"
                  placeholder="tu@email.com"
                  value={user.Email}
                  onChange={handleChange}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  required
                />
                {emailError && <p className="text-red-400 text-sm mt-1">{emailError}</p>}
              </div>
              
              <div>
                <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="phone">
                  Número de Teléfono
                </label>
                <input
                  id="phone"
                  type="tel"
                  name="PhoneNumber"
                  placeholder="+56 9 1234 5678"
                  value={user.PhoneNumber}
                  onChange={handleChange}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                />
              </div>
            </div>
            
            {/* Fecha de Nacimiento y País en la misma fila */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="birthDate">
                  Fecha de Nacimiento
                </label>
                <input
                  id="birthDate"
                  type="date"
                  name="DateOfBirth"
                  value={user.DateOfBirth}
                  onChange={handleChange}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  required
                />
              </div>
              
              <div>
                <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="country">
                  País
                </label>
                <select
                  id="country"
                  name="Country"
                  value={user.Country}
                  onChange={handleChange}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  required
                >
                  <option value="" disabled>Seleccionar país</option>
                  {paises.map((pais, index) => (
                    <option key={index} value={pais}>{pais}</option>
                  ))}
                </select>
              </div>
            </div>
            
            {/* Contraseña y Confirmar Contraseña en la misma fila */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="password">
                  Contraseña
                </label>
                <input
                  id="password"
                  type="password"
                  name="Password"
                  placeholder="•••••••••••"
                  value={password}
                  onChange={handlePasswordChange}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  required
                />
                {passwordError && <p className="text-red-400 text-sm mt-1">{passwordError}</p>}
              </div>
              
              <div>
                <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="confirmPassword">
                  Confirmar Contraseña
                </label>
                <input
                  id="confirmPassword"
                  type="password"
                  name="ConfirmPassword"
                  placeholder="•••••••••••"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  required
                />
                {passwordMatchError && <p className="text-red-400 text-sm mt-1">{passwordMatchError}</p>}
              </div>
            </div>
            
            <div className="flex items-center mb-6">
              <input 
                id="terms" 
                type="checkbox" 
                className="w-4 h-4 text-red-600 bg-zinc-800 border-zinc-700 rounded focus:ring-red-500"
                required
              />
              <label htmlFor="terms" className="ml-2 text-sm text-gray-300">
                Acepto los <a href="#" className="text-red-400 hover:underline">Términos y Condiciones</a> y la <a href="#" className="text-red-400 hover:underline">Política de Privacidad</a>
              </label>
            </div>
            
            <button 
              type="submit" 
              className="w-full group relative flex justify-center py-3 px-4 border border-transparent rounded-lg
                      text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 
                      focus:ring-red-500 font-bold transition duration-300"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <svg className="h-5 w-5 text-red-400 group-hover:text-red-300" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" clipRule="evenodd" />
                </svg>
              </span>
              Registrarme
            </button>
          </form>
          
          <div className="px-8 py-6 bg-zinc-950 text-center">
            <p className="text-gray-300">
              ¿Ya tienes cuenta? <a href="/" className="text-red-400 hover:underline font-bold">Inicia sesión</a>
            </p>
            <p className="text-xs text-gray-500 mt-4">
              Al registrarte, aceptas recibir correos con nuestras ofertas y actualizaciones de eventos de comedia.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;